import React from "react";
import Typography from "ui/Typography";

import { $CalloutContainer, $CalloutWrapper } from "./styled-components";

type CalloutProps = {
  children: React.ReactNode;
  text: string;
  heading?: string;
  /**
   * className is forwarded to the inner $CalloutContainer
   * as $CalloutWrapper is just used for positioning the
   * callout against it's intended element
   */
  className?: string;
  position?: "right" | "top";
  size?: "small" | "medium";
  isVisible?: boolean;
  /**
   * shouldAnimate currently has no effect because it's been disabled while we
   * investigate a bug: https://app.clubhouse.io/czi-edu/story/126564
   * TODO: When the bug has been fixed, revert this PR: https://github.com/chanzuckerberg/along/pull/2176
   */
  shouldAnimate?: boolean;
};

export default function Callout({
  heading,
  text,
  children,
  className,
  position = "right",
  size = "medium",
  isVisible = true,
}: CalloutProps) {
  return (
    <$CalloutWrapper>
      {children}
      {isVisible && (
        <$CalloutContainer
          className={className}
          $position={position}
          $size={size}
        >
          {!heading ? null : (
            <Typography
              textAlign="center"
              size="subheading"
              color="ColorSpace500"
            >
              {heading}
            </Typography>
          )}
          <Typography textAlign="center" size="tooltip" color="ColorSpace500">
            {text}
          </Typography>
        </$CalloutContainer>
      )}
    </$CalloutWrapper>
  );
}
